import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { SalespointDocument } from '../../../../domain/document.model';
import { ValidationError } from '../../../../domain/error.model';
import { ClauseType } from '../../../../domain/offer.domain';
import { SystemUser } from '../../../../domain/user.model';
import { ErrorAwareComponent, LsnErrorStateMatcher } from '../../../shared/middleware/error-state-matcher';
import { ErrorsState } from '../../store/errors.state';
import { UserState } from '../../store/user.state';

@Component({
    selector: 'app-clauses',
    templateUrl: './clauses.component.html',
    styleUrls: ['./clauses.component.scss']
})
export class ClausesComponent implements OnInit, OnDestroy, ErrorAwareComponent {

    @Select(UserState.getUser) user$: Observable<SystemUser>;

    @Input() offer: SalespointDocument;
    @Input() readonly = false;
    @Input() prefix = '';

    types: number;
    clauseType = ClauseType;
    subscriptions: Subscription[] = [];
    errors: ValidationError[];

    extended = {
        [ClauseType.CLIENT_CONDITION_1]: false,
        [ClauseType.CLIENT_CONDITION_2]: false,
    };

    matchers = {
        [ClauseType.CLIENT_DECLARATION_1]: new LsnErrorStateMatcher(this, `clauseMap[${ClauseType.CLIENT_DECLARATION_1}]`),
        [ClauseType.CLIENT_DECLARATION_2]: new LsnErrorStateMatcher(this, `clauseMap[${ClauseType.CLIENT_DECLARATION_2}]`),

        [ClauseType.CLIENT_CONDITION_1]: new LsnErrorStateMatcher(this, `clauseMap[${ClauseType.CLIENT_CONDITION_1}]`),
        [ClauseType.CLIENT_CONDITION_2]: new LsnErrorStateMatcher(this, `clauseMap[${ClauseType.CLIENT_CONDITION_2}]`),

        [ClauseType.AGENT_DECLARATION_1]: new LsnErrorStateMatcher(this, `clauseMap[${ClauseType.AGENT_DECLARATION_1}]`),
        [ClauseType.AGENT_DECLARATION_2]: new LsnErrorStateMatcher(this, `clauseMap[${ClauseType.AGENT_DECLARATION_2}]`),
        [ClauseType.AGENT_DECLARATION_3]: new LsnErrorStateMatcher(this, `clauseMap[${ClauseType.AGENT_DECLARATION_3}]`),
    };

    get agentChecked(): boolean {
        return this.offer.additionalData.clauseMap[ClauseType.AGENT_DECLARATION_1]
            && this.offer.additionalData.clauseMap[ClauseType.AGENT_DECLARATION_2]
            && this.offer.additionalData.clauseMap[ClauseType.AGENT_DECLARATION_3];
    }

    set agentChecked(value) {
        [ClauseType.AGENT_DECLARATION_1, ClauseType.AGENT_DECLARATION_2, ClauseType.AGENT_DECLARATION_3]
            .forEach(e => this.offer.additionalData.clauseMap[e] = value);
    }

    constructor(private store: Store) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(ErrorsState.getMainErrors).subscribe(errors => this.errors = errors)
        );
        this.matchers = {
            [ClauseType.CLIENT_DECLARATION_1]: new LsnErrorStateMatcher(this, `${this.prefix}clauseMap[${ClauseType.CLIENT_DECLARATION_1}]`),
            [ClauseType.CLIENT_DECLARATION_2]: new LsnErrorStateMatcher(this, `${this.prefix}clauseMap[${ClauseType.CLIENT_DECLARATION_2}]`),

            [ClauseType.CLIENT_CONDITION_1]: new LsnErrorStateMatcher(this, `${this.prefix}clauseMap[${ClauseType.CLIENT_CONDITION_1}]`),
            [ClauseType.CLIENT_CONDITION_2]: new LsnErrorStateMatcher(this, `${this.prefix}clauseMap[${ClauseType.CLIENT_CONDITION_2}]`),

            [ClauseType.AGENT_DECLARATION_1]: new LsnErrorStateMatcher(this, `${this.prefix}clauseMap[${ClauseType.AGENT_DECLARATION_1}]`),
            [ClauseType.AGENT_DECLARATION_2]: new LsnErrorStateMatcher(this, `${this.prefix}clauseMap[${ClauseType.AGENT_DECLARATION_2}]`),
            [ClauseType.AGENT_DECLARATION_3]: new LsnErrorStateMatcher(this, `${this.prefix}clauseMap[${ClauseType.AGENT_DECLARATION_3}]`),
        };
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
